import { AbstractControl } from "@angular/forms";
import momentBusiness from "moment-business-days";
import moment from "moment";

export function RequestDateValidator(control: AbstractControl): null | object {
    if (!control.value) {
        return null;
    }

    const pattern: RegExp = /^(0[1-9]|[12][0-9]|3[01])[\/](0[1-9]|1[012])[\/](19|20)\d\d$/;
    const minDate = momentBusiness().businessAdd(3);

    const valid: boolean = pattern.test(control.value);

    return valid && moment(control.value, "DD/MM/YYYY").isAfter(minDate) ? null : { pattern: true };
}
